var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container documentation-container"},[_c('dropdown-menu',{staticStyle:{"float":"left","margin-left":"50px"},attrs:{"items":_vm.articleList,"title":"系列文章"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }